import { userEvent } from "../routes";
const createUserEvent = async (data) => {
  try {
    const response = await fetch(userEvent.createRoute, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const createUserEventMyu = async (data) => {
  try {
    const response = await fetch(userEvent.creeateMyuRoute, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getUserEvent = async (data) => {
  if (!data || !data.phoneNumber) {
    console.warn("getUserEvent: Missing phoneNumber");
    return null;
  }
  try {
    const response = await fetch(userEvent.getPhoneRoute, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const checkIsCaptain = async (data) => {
  try {
    const response = await fetch(userEvent.checkIsCaptain, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const checkIsAdmin = async (data) => {
  try {
    const response = await fetch(userEvent.checkIsAdmin, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
} 

const createUserPhone = async (data) => {
  try {
    const response = await fetch(userEvent.createPhoneRoute, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
      throw new Error(`Request failed: ${response.status}`);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getUserByPhone = async (data) => {
  if (!data || !data.phoneNumber) {
    console.warn("getUserByPhone: Missing phoneNumber");
    return null;
  }
  try {
    const response = await fetch(userEvent.getPhoneRoute, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
      throw new Error(`Request failed: ${response.status}`);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const updateTeam = async (data) => {
  try {
    const response = await fetch(userEvent.updateTeam, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export {
  createUserEvent,
  getUserEvent,
  checkIsCaptain,
  updateTeam,
  checkIsAdmin,
  createUserEventMyu,
  createUserPhone,
  getUserByPhone
};
